import type { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/core/components/ui/dialog";

/**
 * The dialog every pricebook pick opens in. Its body mounts only while open,
 * so a reopened dialog starts from a fresh search.
 */
export const PricebookMatchDialog = ({
  open,
  onOpenChange,
  saving,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** A save in flight holds the dialog open, so its outcome has somewhere to land. */
  saving: boolean;
  children: ReactNode;
}) => (
  <Dialog
    open={open}
    onOpenChange={(next) => {
      if (saving) return;
      onOpenChange(next);
    }}
  >
    <DialogContent
      className="max-w-[560px] gap-6"
      description="Choose the pricebook item this line is for"
    >
      <DialogHeader className="pb-0 text-left">
        <DialogTitle>Match line to a pricebook item</DialogTitle>
      </DialogHeader>
      {open && children}
    </DialogContent>
  </Dialog>
);
